




























import {Component, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import CompanyBookApi from "@/api/CompanyBookApi";
import companyBookModule from "@/store/module/CompanyBookModule";
import BookInfoView from "@/view/book-manage/book/info.vue";
import BookTaskView from "@/view/book-manage/book/task.vue";

@Component({
    components: {
        BookInfoView,
        BookTaskView,
    },
})
export default class BookDetailView extends Vue {

    @Inject
    private cbookApi!: CompanyBookApi

    private leftColSpan = 2
    private rightColSpan = 10

    private get cbook() {
        return companyBookModule.active
    }

    private async created() {
        const id = String(this.$route.query.id)
        const cbook = await this.cbookApi.detail(id)
        await companyBookModule.activate(cbook)
    }

    private destroyed() {
        companyBookModule.destroy()
    }
}
